import {orderDeliveryService} from "../../../services";
import InputField from "../../input-field";
import React, {useEffect, useState} from 'react';
import {Button, Col, DatePicker, Modal, notification, Row, Spin} from "antd";
import '../modals.css';
import FieldBlock from "../../field-block";
import moment from "moment";
import i18n from "../../../i18n";

export default function ModalMakeCounteroffer({
                                                isShow,
                                                setIsShow,
                                                orderDeliveryId,
                                                setLoadingMainModal,
                                                orderDateLoading,
                                                setNeedUpdateContact
                                              }) {

  const [loading, setLoading] = useState(false);
  const [fieldsErrors, setFieldsErrors] = useState([]);

  const [sum, setSum] = useState(0);
  const [dateLoading, setDateLoading] = useState(null);

  let bigButtonStyle = {
    width: '300px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    marginTop: '60px'
  };

  useEffect(() => {
    if (orderDateLoading && isShow) {
      let date = moment(orderDateLoading, 'YYYY-MM-DD');
      setDateLoading(date);
    }
  }, [orderDateLoading, isShow]);

  const onClickMakeCounteroffer = () => {
    setLoading(true);

    const counterofferData = {
      orderDeliveryId: orderDeliveryId,
      sum: sum,
      dateLoading: dateLoading.format('DD.MM.YYYY'),
    };

    orderDeliveryService.makeCounteroffer(counterofferData)
      .then((response) => {
        setLoading(false);
        if (response.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.makeCounteroffer.success'),
            description: response.message,
          });

          setLoading(false);
          setIsShow(false);
          setNeedUpdateContact(true);
          setLoadingMainModal('counteroffer');
        } else if (response.status === 'error') {
          notification.error({
            message: i18n.t('components.notification.titles.makeCounteroffer.error'),
            description: response.message,
          });

          setLoading(false);
          setFieldsErrors(response.errors);
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.makeCounteroffer.error2'),
          description: error,
        });

        setLoading(false);
      });
  };

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  return (
    <Modal
      title={<span className="ant-modal-title">{i18n.t('modals.modalMakeCounteroffer.title')}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '650px'}}
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={[
        <Button htmlType="submit" style={bigButtonStyle} key="submit" type="primary"
                onClick={onClickMakeCounteroffer}>{i18n.t('main.buttons.send')}</Button>,
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row gutter={[12, 24]}>
          <Col lg={6} md={6} sm={6} xs={6}>
            <InputField
              name="name" label={i18n.t('modals.modalMakeCounteroffer.fields.name.title')}
              value={sum} setValue={setSum}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={6} md={6} sm={6} xs={6}>
            <FieldBlock name="dateLoading" title={i18n.t('modals.modalMakeCounteroffer.fields.dateLoading.title')} getErrors={getFieldErrors}>
              <DatePicker
                style={{width: "100%"}}
                defaultValue={dateLoading}
                value={dateLoading}
                format="DD.MM.YYYY"
                size="large"
                name="dateLoading"
                onChange={value => {
                  setDateLoading(value);
                }}
              />
            </FieldBlock>
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
}
